import { cn } from "../../utils/classNames";

const variants = {
  purple: "border-hookd-empress/50 bg-hookd-empress/15 text-hookd-cream",
  gold: "border-hookd-gold/45 bg-hookd-gold/12 text-hookd-gold",
  pink: "border-hookd-neon/45 bg-hookd-neon/12 text-hookd-neon",
  green: "border-green-400/45 bg-green-400/12 text-green-300",
  neutral: "border-white/10 bg-white/5 text-hookd-muted",
};

export default function Badge({ children, variant = "purple", className = "" }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-md border px-2 py-1 text-xs font-semibold capitalize",
        variants[variant] || variants.purple,
        className
      )}
    >
      {children}
    </span>
  );
}
